<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>静态资源</span>
        </div>

        <el-card style="margin-bottom: 15px;">
          <el-form>
            <el-form-item label="刷新URL">
              <el-input v-model="refreshParam.path" placeholder="/path/object" type="textarea" style="width: 500px;" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="refresh">刷新</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!--        <el-card style="margin-bottom: 15px;">-->
        <!--          <proxyConfig />-->
        <!--        </el-card>-->

        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="当前版本">
            <el-select v-model="queryParams.type" class="mleft" placeholder="请选择" @change="changeVersion">
              <el-option
                v-for="item in versionArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button v-permisaction="['config:staticConfig:add']" :loading="loading" class="mleft" type="primary" @click="add()">+</el-button>
            <el-button v-permisaction="['config:staticConfig:add']" :loading="loading" type="warning" @click="onSubmit()">保存</el-button>
            <el-button v-permisaction="['config:staticConfig:add']" :loading="loading" @click="download(queryParams.type)">打包下载</el-button>
            <el-upload
              ref="upload2"
              style="display: inline-block;margin-left: 10px"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="zip,7z"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res,-1,-1)}"
              :before-upload="beforeUpload2"
              :headers="headers"
            >
              <el-button v-permisaction="['config:staticConfig:upload']" :loading="loading" icon="el-icon-upload2" type="success">压缩包上传</el-button>
            </el-upload>
            <el-button v-if="formData.length > 0" v-permisaction="['config:staticConfig:copy']" :loading="loading" class="mleft" type="primary" @click="copy()">拷贝当前版本 v{{ queryParams.type }} <i class="el-icon-caret-right" /></el-button>
            <el-select v-if="formData.length > 0" v-model="queryParams.version" class="mleft" placeholder="请选择">
              <el-option
                v-for="item in versionArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="queryParams.type ===item.value "
              />
            </el-select>
          </el-form-item>

          <!--          <el-table-->
          <!--            :data="formData"-->
          <!--            border-->
          <!--            style="width: 100%;"-->
          <!--          >-->
          <!--            <el-table-column-->
          <!--              label="KEY"-->
          <!--              align="center"-->
          <!--            >-->
          <!--              <template v-slot:default="scope">-->
          <!--                <el-input v-model.trim="scope.row.config" placeholder="KEY" />-->
          <!--              </template>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column-->
          <!--              label="路径"-->
          <!--              align="center"-->
          <!--            >-->
          <!--              <template v-slot:default="scope">-->
          <!--                {{ scope.row.path }}-->
          <!--                &lt;!&ndash;                <el-input v-model.trim="scope.row.path" readonly placeholder="KEY" />&ndash;&gt;-->
          <!--              </template>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column-->
          <!--              label="备注"-->
          <!--              align="center"-->
          <!--            >-->
          <!--              <template v-slot:default="scope">-->
          <!--                <el-input v-model.trim="scope.row.mark" placeholder="备注" />-->
          <!--              </template>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column-->
          <!--              label="操作"-->
          <!--              align="center"-->
          <!--            >-->
          <!--              <template v-slot:default="scope">-->
          <!--                <el-upload-->
          <!--                  ref="upload"-->
          <!--                  style="display: inline;float: left;margin: 0px"-->
          <!--                  class="upload-demo"-->
          <!--                  :action="sys_app_logoAction"-->
          <!--                  accept="zip,xlsx"-->
          <!--                  :limit="1"-->
          <!--                  :on-success="(res)=>{return importUploadSuccess(res, scope.$index, scope.row.config)}"-->
          <!--                  :before-upload="beforeUpload"-->
          <!--                  :headers="headers"-->
          <!--                >-->
          <!--                  <el-button v-permisaction="['config:staticConfig:upload']" :disabled="scope.row._id <= 0" icon="el-icon-upload2" type="primary">上传</el-button>-->
          <!--                </el-upload>-->

          <!--                <el-button :disabled="scope.row._id <= 0" icon="el-icon-tickets" :loading="loading" type="success" @click="getJson(scope.row.path)">预览</el-button>-->
          <!--                <el-button :disabled="scope.row._id <= 0" icon="el-icon-tickets" :loading="loading" type="info" @click="downloadFile(scope.row.path)">下载</el-button>-->
          <!--                <el-button v-permisaction="['config:staticConfig:del']" :disabled="scope.row._id <= 0" type="danger" @click="del(scope.row.config, scope.row._id, scope.$index)">删除</el-button>-->
          <!--              </template>-->
          <!--            </el-table-column>-->
          <!--          </el-table>-->

          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="KEY">
              <el-input v-model.trim="item.config" style="width: 300px;" placeholder="KEY" />
            </el-form-item>
            <el-form-item label="路径">
              <el-input v-model="item.path" readonly style="width: 400px;" placeholder="路径" />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="item.mark" style="width: 300px;" placeholder="备注" />
            </el-form-item>
            <el-form-item v-if="item._id > 0">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="zip,xlsx"
                :limit="1"
                :on-success="(res)=>{return importUploadSuccess(res, index, item.config)}"
                :before-upload="beforeUpload"
                :headers="headers"
              >
                <el-button v-permisaction="['config:staticConfig:upload']" :loading="loading" icon="el-icon-upload2" type="primary">上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:staticConfig:del']" :loading="loading" type="danger" @click="del(item.config, item._id, index)">删除</el-button>
            </el-form-item>
            <el-form-item v-if="item._id > 0">
              <el-button icon="el-icon-tickets" :loading="loading" type="success" @click="getJson(item.path)">预览</el-button>
            </el-form-item>
            <!--            <el-form-item v-if="item._id > 0">-->
            <!--              <el-button icon="el-icon-download" :loading="loading" type="info" @click="downloadFile(item.path)">下载</el-button>-->
            <!--            </el-form-item>-->
          </el-row>
        </el-form>
      </el-card>

      <el-drawer
        size="50%"
        title="我是标题"
        :visible.sync="drawer"
        :with-header="false"
      >
        <json-viewer sort :expand-depth="2" expanded boxed copyable :value="jsonData" />
      </el-drawer>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)
import 'vue-json-viewer/style.css'
import { getToken } from '@/utils/auth'
import {
  batchDown,
  copyStaticCfg,
  delStaticCfg,
  getStaticList,
  makeStaticJson,
  ossSyncS3,
  pushObjectCache,
  refreshPath,
  updateStaticCfg,
  uploadJson
} from '@/api/config/staticcfg'
// import proxyConfig from '@/views/config/static-config/components/proxyConfig.vue'
import { getCommonCfg } from '@/api/config/common-cfg'
import axios from 'axios'

export default {
  name: 'StaticConfig',
  components: {
    // proxyConfig
  },
  data() {
    return {
      drawer: false,
      jsonData: '',
      url: '',
      time: 0,
      versionArr: [],
      env: process.env.VUE_APP_ENV,
      loading: false,
      refreshParam: {
        type: 'Directory',
        path: ''
      },
      refreshTypes: [
        { label: '文件刷新', value: 'File' },
        { label: '目录刷新', value: 'Directory' }
      ],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: '',
        version: ''
      },
      formData: [
        {
          _id: 0,
          'config': '',
          'path': '',
          'mark': '',
          'version': ''
        }
      ]
    }
  },
  created() {
    this.getVersion()
    // this.getTables()
  },
  mounted() {
    // console.log('load', this.$refs.upload)
  },
  methods: {
    async  getJson(path) {
      this.loading = true
      try {
        const url = `${this.url}/${path}`
        const response = await axios.get(url, {
          responseType: 'json'
        })
        this.jsonData = response.data
        this.loading = false
        this.drawer = true
      } catch (error) {
        this.msgError('Error fetching data:', error)
      }
    },
    async downloadFile(path) {
      this.loading = true
      try {
        const response = await axios({
          url: `${this.url}/${path}`,
          method: 'GET',
          responseType: 'blob' // Important
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const a = document.createElement('a')
        a.href = url
        a.download = path // Specify the filename you want
        document.body.appendChild(a)
        a.click()
        a.remove()
        this.loading = false
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.msgError('Error downloading file:', error)
        // console.error('Error downloading file:', error)
      }
    },
    refresh() {
      const pathArr = []
      const paths = this.refreshParam.path.split('\n')
      for (const i in paths) {
        if (paths[i].indexOf('/') !== 0) {
          this.msgError(paths[i] + ' 必须以/开头')
          return
        }
        pathArr.push(paths[i])
      }
      this.loading = true
      const data = JSON.stringify(pathArr)
      refreshPath({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.loading = false
        } else {
          this.msgError(res.msg)
          this.loading = false
        }
      })
    },
    download(version) {
      if (!version) {
        this.msgError('版本有误！')
        return
      }
      this.loading = true
      batchDown({ version: version }).then(res => {
        this.loading = false
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data)
      })
    },
    onSubmit(path = null) {
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateStaticCfg({ data: data, name: this.time, type: this.queryParams.type }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          if (path) {
            pushObjectCache({ data: path }).then(r => {
              if (r.code !== 200) {
                this.msgError(r.msg)
              }
            })
          } else {
            this.updateStatic()
          }

          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getStaticData(versionArr = []) {
      if (versionArr.length > 0) {
        for (const i in versionArr) {
          this.queryParams.type = versionArr[i].value
          this.getTables()
          // await this.delay(2000)
          if (this.formData.length > 0) {
            break
          }
        }
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    getTables() {
      this.loading = true
      getStaticList(this.queryParams).then(res => {
        this.loading = false
        this.formData = []
        if (res.data.list.length > 0) {
          res.data.list.forEach(item => {
            this.formData.push({ _id: 1, config: item.config, path: item.path, mark: item.mark, version: item.version })
          })
          this.time = res.data.time
          this.url = res.data.cdn
        }
      })
    },
    add() {
      this.formData.unshift({
        _id: 0,
        'config': '',
        'path': '',
        'mark': '',
        version: this.queryParams.type
      })
    },
    copy() {
      if (!this.queryParams.version) {
        this.msgError('请选择版本')
        return
      }
      const tips = `该操作将 v${this.queryParams.type} 配置 拷贝到 v${this.queryParams.version}, 是否继续?`
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        copyStaticCfg({ name: this.queryParams.type, version: this.queryParams.version }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.queryParams.type = this.queryParams.version
            this.queryParams.version = ''
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    del(key, _id, index) {
      if (_id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          delStaticCfg({ data: key, name: this.queryParams.type }).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData = this.formData.filter((item, key) => {
          return key !== index
        })
      }
    },
    beforeUpload2(file) {
      var extension = file.name.split('.').pop()
      if (extension !== '7z' && extension !== 'zip') {
        this.msgError('只允许上传.7z,.zip文件')
        return false
      }
      return true
    },
    beforeUpload(file) {
      // application/x-zip-compressed
      if (file.type !== 'application/json' && file.type !== 'application/x-zip-compressed' && file.type !== 'application/zip') {
        this.msgError('只允许上传zip,json文件')
        return false
      }
      return true
    },
    importUploadSuccess(response, index, key) {
      this.loading = true
      const _this = this
      this.$refs.upload.forEach(file => {
        file.clearFiles()
      })
      let typ = 0
      if (index === -1 && key === -1) {
        typ = -1
        this.$refs.upload2.clearFiles()
      }
      uploadJson({ data: response.data.path, name: key, type: typ, Id: this.time, version: this.queryParams.type }).then(res => {
        _this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          // this.getTables()
          if (typ !== -1) {
            this.formData.forEach((item, index) => {
              this.formData[index].version = this.queryParams.type
              if (item.config === key) {
                this.formData[index].path = res.data
              }
            })
            this.onSubmit(res.data)
          } else {
            setTimeout(() => {
              this.formData = []
              this.getTables()
            }, 500)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    updateStatic() {
      const tips = `是否同步版本 v${this.queryParams.type} 静态配置到S3?`
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        this.loading = true
        makeStaticJson({ type: this.queryParams.type }).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.msgSuccess('更新成功')
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    ossAsyncS3() {
      this.$confirm('此操作将OSS数据同步到S3, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        ossSyncS3().then(res => {
          this.loading = false
          if (res.code === 200) {
            this.msgSuccess(res.msg)
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getVersion() {
      getCommonCfg({ name: 'StaticVersion' }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.versionArr.unshift({ label: item, value: item })
          })
          const count = this.versionArr.length
          if (count > 0) {
            // this.queryParams.type = this.versionArr[count - 1].value
            this.getStaticData(this.versionArr)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    changeVersion(v) {
      this.queryParams.type = v
      this.getTables()
    }
  }
}
</script>

<style scoped>
 .mleft{
   margin-left: 10px;
 }
</style>
